import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { ParamProvider } from './components/providers/ParamsContextProvider.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ParamProvider>
      <App />
    </ParamProvider>
    
  </StrictMode>,
)
